import { render, staticRenderFns } from "./DebugmenuPage.vue?vue&type=template&id=a7aecb28"
import script from "./DebugmenuPage.vue?vue&type=script&lang=js"
export * from "./DebugmenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports